<template>
  <section class="space-y-2 p-4">
    <viewTitle
      title="业务管理 / 报表管理 / 木片送货情况日报"
      :showReturn="true"
    >
      <template slot="return">
        <el-button
          v-has="['c-mpReport-record-deliverExport']"
          type="primary"
          @click="onExport"
          size="small"
          >导出</el-button
        >
      </template>
    </viewTitle>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="基地">
        <el-select class="w-40" clearable v-model="queryParam.base_id">
          <el-option
            v-for="item in com_list"
            :key="item.com_id"
            :label="item.com_name"
            :value="item.com_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日期">
        <el-date-picker
          class="!w-96"
          style="margin-bottom: 10px;"
          v-model="timeRange"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="物料描述">
        <el-input
          clearable
          v-model="queryParam.chip_type"
          placeholder="请输入物料描述"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="refreshData" type="primary" size="small"
          >刷新数据</el-button
        >
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
      class="mt-4"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="id"
      @loadPage="loadData"
    >
      <template slot="remark" slot-scope="scope">
        <el-input
          type="textarea"
          :autosize="{ minRows: 1 }"
          placeholder="请输入"
          @blur="onBlur(scope.row)"
          v-model="scope.row.remark"
        >
        </el-input>
      </template>
    </c-table>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import moment from 'moment';
export default {
  data() {
    return {
      dataSource: [{}],
      columns: [
        { label: "基地", prop: "company_name" },
        { label: "日期", prop: "chip_day" },
        { label: "物料描述", prop: "chip_type" },
        { label: "打卡车数", prop: "clock_num" },
        { label: "卸货车次", prop: "unload_num" },
        {
          label: "厂外排队等待时长",
          prop: "queue_time",
          group: [
            { 
              label: "当天平均厂外排队时长",
              prop: "queue_time_avg",
              formatData: row => this.formatTime(row.queue_time_avg)
            },
            { 
              label: "当天单车最短厂外排队时长", 
              prop: "queue_time_min",
              formatData: row => this.formatTime(row.queue_time_min)
            },
            { 
              label: "当天单车最长厂外排队时长", 
              prop: "queue_time_max",
              formatData: row => this.formatTime(row.queue_time_max)
            }
          ]
        },
        {
          label: "厂内卸货时长",
          prop: "unload_time",
          group: [
            { 
              label: "当天平均卸货时长", 
              prop: "unload_time_avg",
              formatData: row => this.formatTime(row.unload_time_avg)
            },
            { 
              label: "当天单车卸货最短时长", 
              prop: "unload_time_min",
              formatData: row => this.formatTime(row.unload_time_min)
            },
            { 
              label: "当天单车卸货最长时长", 
              prop: "unload_time_max",
              formatData: row => this.formatTime(row.unload_time_max)
            }
          ]
        },
        {
          label: "送货时长统计",
          prop: "deliver_time",
          group: [
            { 
              label: "当天平均送货时长",
              prop: "deliver_time_avg",
              formatData: row => this.formatTime(row.deliver_time_avg)
            },
            { 
              label: "当天单车最短送货时长", 
              prop: "deliver_time_min",
              formatData: row => this.formatTime(row.deliver_time_min)
            },
            { 
              label: "当天单车最长送货时长", 
              prop: "deliver_time_max",
              formatData: row => this.formatTime(row.deliver_time_max)
            },
            {
              label: "当天送货时长超24小时未完成送货的车次总和",
              prop: "deliver_time_24",
              // formatData: row => this.formatTime(row.deliver_time_24)
            }
          ]
        },
        { label: "备注", prop: "remark" }
      ],
      exportDataEvent: params => {
        const { begin_time, end_time, ...otherParams } = params;
        return this.$common.http({
          url: "/api/queue/admin/unit_deliver_report_export",
          data: {
            ...otherParams,
            begin_clock_time: begin_time,
            end_clock_time: end_time
          },
          noLoading: true
        });
      },
      fetchDataEvent: params => {
        const { begin_time, end_time, ...otherParams } = params;
        return this.$common.http({
          url: "/api/queue/admin/unit_deliver_report_list",
          data: {
            ...otherParams,
            begin_clock_time: begin_time,
            end_clock_time: end_time
          }
        });
      },
      loadCallBack: () => {
        this.dataSource = this.dataSource.map((item) => {
          return {
            ...item,
            old_remark: item.remark
          }
        })
      }
    };
  },
  mixins: [initListMinxin],
  methods: {
    formatTime(timestampInSeconds) {
      if (!timestampInSeconds) {
        return `00:00:00`;
      }
      // 使用moment.duration创建时长对象
      const duration = moment.duration(timestampInSeconds, 'seconds');
      // 格式化为HH:mm:ss
      // 注意：moment默认的format不支持duration的format，我们需要手动计算
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      // 使用padStart确保两位数格式
      const formattedTime = [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        seconds.toString().padStart(2, '0')
      ].join(':');
      return formattedTime;
    },
    onBlur(row) {
      this.$confirm('确认修改备注?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$common.http({
          url: "/api/queue/admin/unit_deliver_report_update",
          data: {
            id: row.id,
            remark: row.remark
          }
        }).then(() => {
          this.refreshData();
        })
      }).catch(() => {
        row.remark = row.old_remark;
      })
    }
  }
};
</script>
<style lang="less" scoped></style>
